let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("giTS8")).then(() => parcelRequire('2gjt2'));